var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "completeStock" },
    [
      _c("div", { staticClass: "title" }, [
        _c("p", [
          _vm._v(
            "主订单号：" +
              _vm._s(_vm.orderNo) +
              "(" +
              _vm._s(_vm.orderstatus) +
              ")"
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "oper-btns" },
          [
            !_vm.isFactory
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.orderstatus === "备货中",
                        expression: "orderstatus==='备货中'"
                      }
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.autoStock }
                  },
                  [_vm._v("自动拣货")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.printList }
              },
              [_vm._v("导出货物清单")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "orderForm",
          attrs: {
            "label-position": "right",
            rules: _vm.packageRule,
            "status-icon": "",
            model: _vm.orderForm
          }
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.orderForm.orderTableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { label: "No", type: "index", width: "40" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "order_number", label: "子订单", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ruigu_code", label: "锐锢编码" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "self_code", label: "三方编码" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称", width: "320" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "unit", label: "单位" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "amount", label: "订购数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "send_amount", label: "实发数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.orderstatus === "备货中" &&
                        !(
                          scope.row.status === "-1" ||
                          scope.row.status === "-2" ||
                          scope.row.status === "-3"
                        )
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "orderTableData." +
                                    scope.$index +
                                    ".send_amount",
                                  rules:
                                    scope.row.status !== "-1" &&
                                    scope.row.status !== "-2" &&
                                    scope.row.status !== "-3"
                                      ? _vm.packageRule.send_amount
                                      : []
                                }
                              },
                              [
                                _vm.orderstatus === "备货中" &&
                                !(
                                  scope.row.status === "-1" ||
                                  scope.row.status === "-2" ||
                                  scope.row.status === "-3"
                                )
                                  ? _c("el-input", {
                                      model: {
                                        value: scope.row.send_amount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "send_amount",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.send_amount"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.orderstatus !== "备货中",
                                expression: "orderstatus!=='备货中'"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(scope.row.send_amount))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "od_statusName",
                  label: "状态"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isFactory
        ? _c("div", { staticClass: "package" }, [
            _c(
              "div",
              { staticClass: "weightTable" },
              [
                _c("p", { staticClass: "subtable blue" }, [_vm._v("按主订单")]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "weightForm",
                    attrs: {
                      "label-position": "right",
                      rules: _vm.weightRule,
                      "status-icon": "",
                      model: _vm.weightForm
                    }
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.weightData, border: "" }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "weight", label: "总重量(kg)" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "weight" } },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: _vm.weightForm.weight,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.weightForm,
                                                "weight",
                                                $$v
                                              )
                                            },
                                            expression: "weightForm.weight"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1735269216
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "box_num", label: "打包数" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "box_num" } },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: _vm.weightForm.box_num,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.weightForm,
                                                "box_num",
                                                $$v
                                              )
                                            },
                                            expression: "weightForm.box_num"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2329142464
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "box_codes",
                            label: "箱码",
                            width: "535"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "weight" } },
                                      _vm._l(_vm.weightForm.box_codes, function(
                                        item
                                      ) {
                                        return _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.showBox,
                                                expression: "showBox"
                                              }
                                            ],
                                            key: item.id,
                                            staticClass: "box_codes",
                                            class: {
                                              active: item.active === true
                                            },
                                            attrs: { index: item.box_code },
                                            on: {
                                              click: function($event) {
                                                return _vm.getBoxData(item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.box_code) +
                                                "\n                  "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-close",
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteBox(item.id)
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3807459733
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFactory
        ? _c(
            "div",
            { staticClass: "bottom" },
            [
              _c("p", [_vm._v("生成箱码总数：" + _vm._s(_vm.total_box_num))]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.orderstatus === "备货中",
                      expression: "orderstatus==='备货中'"
                    }
                  ],
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.completeStock }
                },
                [_vm._v("备货完成")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.orderstatus !== "备货中",
                      expression: "orderstatus!=='备货中'"
                    }
                  ],
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: _vm.saveLoading,
                    loading: _vm.saveLoading
                  },
                  on: { click: _vm.save }
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.print }
                },
                [_vm._v("打印全部箱码")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.printOneBox }
                },
                [_vm._v("补打箱码")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.clearBox }
                },
                [_vm._v("清除全部箱码")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showLogisticsSheet,
                      expression: "showLogisticsSheet"
                    }
                  ],
                  staticStyle: { float: "right" },
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.printLogisticsSheet }
                },
                [_vm._v("通知物流取货")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("boxcode", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        ref: "refboxcode"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-585dc388", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-585dc388","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/completeStock.vue
// module id = null
// module chunks = 